import { Component, OnInit, Input } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Book } from '../../../../shared/models/book';
import { EditorService } from '../../editor.service';
import { EditOptionService } from '../../editOptions.service';
import { BookData } from '../../../../shared/models/bookData';
import { Page } from '../../../../shared/models/page';
@Component({
  selector: 'app-mediacategories',
  templateUrl: './mediacategories.component.html',
  styleUrls: ['./mediacategories.component.css']
})
export class MediacategoriesComponent implements OnInit {
  @Input() data: any;
  public bookObj: Book;
  public bookDataObj: BookData;
  public pageObj: Page;
  constructor(private http: HttpClient, private editorService: EditorService, private editorOptionsService: EditOptionService) { }
  googleImageData
  ngOnInit() {
    this.bookObj = this.data.popupProps.curComp.bookObj;
    this.bookDataObj = this.data.popupProps.curComp.bookDataObj;
    this.pageObj = this.data.popupProps.curComp.pageObj;
  }

  onChnageGimage(img) {
    let layer = this.editorService.getIframeReference();
    let obj = {
      'type': 'image',
      'url': img.url
    }
    layer.setPageStyle(obj);
    layer.setPageBackGroundStyle(obj);
    this.pageObj.isCustomBg = true;
    this.bookDataObj[this.pageObj.id + ""] = this.pageObj;
    this.editorOptionsService.updateBookDataObj(this.bookDataObj);

  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/mediacategories/mediacategories.component.ts